import { FileType } from "../../../../models";
import { DeveloperProjectCardWithTabsTemplate } from "../../../../templates/DeveloperProjectCardWithTabsTemplate";
import { useProject } from "./useProject";

const Project = (): JSX.Element => {
  const { projectDetails, publicProjectDetails, handleBackClick, tabsList, backButtonText } = useProject();
  const developer = projectDetails?.developer ?? publicProjectDetails?.developer;

  return (
    <DeveloperProjectCardWithTabsTemplate
      activeElement="Projects"
      pageTitle={projectDetails?.displayName ?? publicProjectDetails?.displayName}
      projectCode={projectDetails?.standard.displayName ?? publicProjectDetails?.standard?.displayName}
      projectVerifier={projectDetails?.validator?.displayName ?? publicProjectDetails?.validator?.displayName}
      projectDeveloper={developer?.displayName}
      projectDeveloperIcon={developer?.files?.find((f) => f.type === FileType.SmallLogo)?.file.url}
      projectStatus={projectDetails?.status}
      projectUuid={projectDetails?.uuid}
      tabsList={tabsList}
      backButtonText={backButtonText}
      handleBackClick={handleBackClick}
    />
  );
};

export default Project;
